export default __webpack_public_path__ + "static/media/bl.66cdc56c.svg";